import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import noImage from '../../assets/images/no-image.png';

function ProductImageThumb({ src, alt, placement }) {
  const { t } = useTranslation('common');
  const popoverId = useId();
  const imageSrc = src || noImage;
  const ariaLabel = alt || t('COMMON_LABEL.PRODUCT_IMAGE');

  const popover = (
    <Popover id={popoverId} className="product-image-popover">
      <Popover.Content className="product-image-popover__content">
        <img src={imageSrc} alt={ariaLabel} className="product-image-popover__img" />
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger placement={placement} overlay={popover} trigger={['hover', 'focus']} delay={{ show: 150, hide: 100 }}>
      <div className="product-image" style={{ backgroundImage: `url(${imageSrc})` }} aria-label={ariaLabel} role="img" />
    </OverlayTrigger>
  );
}

ProductImageThumb.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  placement: PropTypes.string,
};

ProductImageThumb.defaultProps = {
  src: '',
  alt: '',
  placement: 'right',
};

export default ProductImageThumb;
